import moment from 'moment-timezone';

import { TIME_OF_DAY_WITH_TZ_FORMAT } from '../../../utils/dateTime';

import { Button } from '@vivaahealth/design-system';

import * as api from '../../../api';

import styles from '../index.module.css';
import { ModalContainer } from '../../ModalContainer';

interface Props {
  show: boolean;
  selectedSlot: api.EhrTimeSlot.EhrTimeSlot;
  timezone: string;
  onAppointmentSelected: (appointment: api.EhrTimeSlot.EhrTimeSlot) => void;
  onCloseModal: (
    auditLog: api.Log.PrevisitAuditAction,
    previsitLog: api.Log.PrevisitAction,
  ) => void;
}

const TimeSlotConfirmationModal: React.FC<Props> = ({
  show,
  selectedSlot,
  timezone,
  onAppointmentSelected,
  onCloseModal,
}) => {
  return (
    <ModalContainer
      isOpen={show}
      header={false}
      onModalClose={() =>
        onCloseModal(
          api.Log.PrevisitAuditAction
            .PatientPrevisitSchedulingSlotConfirmationModalClosed,
          api.Log.PrevisitAction.SchedulingSlotConfirmationModalClosed,
        )
      }
    >
      <div data-testid="confirmation-modal">
        <div className={styles.TimeSlotModalContent}>
          <div className={styles.TimeSlotModalText}>
            Confirm your time to schedule this appointment:
          </div>
          <div className={styles.TimeSlotModalText}>
            {moment(selectedSlot.startTime).tz(timezone).format('MMMM Do')},{' '}
            {moment(selectedSlot.startTime)
              .tz(timezone)
              .format(TIME_OF_DAY_WITH_TZ_FORMAT)}
          </div>
          <Button
            onClick={() => {
              onCloseModal(
                api.Log.PrevisitAuditAction
                  .PatientPrevisitSchedulingSlotConfirmationModalConfirmed,
                api.Log.PrevisitAction.SchedulingSlotConfirmationModalConfirmed,
              );
              onAppointmentSelected(selectedSlot);
            }}
            fullWidth
          >
            Yes, schedule my appointment
          </Button>
          <Button
            variant="outlined"
            onClick={() =>
              onCloseModal(
                api.Log.PrevisitAuditAction
                  .PatientPrevisitSchedulingSlotConfirmationModalCanceled,
                api.Log.PrevisitAction.SchedulingSlotConfirmationModalCanceled,
              )
            }
            fullWidth
          >
            No, select another time
          </Button>
        </div>
      </div>
    </ModalContainer>
  );
};

export default TimeSlotConfirmationModal;
